import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useFeatureFlag } from "@/services/features/hook";
import { FeatureFlags } from "@/services/features/types";
import { LeadDealSuggestionStatuses, LeadStatus } from "../../types";

// A "Convert" button in a lead-to-deal notification lands on the lead page with
// ?convert=1. Open the convert modal once, only while the lead can still be
// converted, then drop the param so a reload or back-navigation doesn't reopen it.
export const useConvertDeepLink = (
  leadStatus: LeadStatus | undefined,
  openConvertModal: () => void
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { enabled, loading } = useFeatureFlag(
    FeatureFlags.CRM_10630_LEAD_TO_DEAL_SUGGESTION
  );
  const wantsConvert = searchParams.get("convert") === "1";

  useEffect(() => {
    if (!wantsConvert || loading || leadStatus === undefined) {
      return;
    }
    if (enabled && LeadDealSuggestionStatuses.includes(leadStatus)) {
      openConvertModal();
    }
    setSearchParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete("convert");
        return next;
      },
      { replace: true }
    );
    // openConvertModal is recreated each render; the param is consumed once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsConvert, loading, enabled, leadStatus]);
};
